<script setup lang="ts">
defineEmits(['click']);
</script>

<template>
  <button
    class="flex w-full items-center gap-2 rounded-md p-2 transition-colors duration-100 hover:cursor-pointer hover:bg-gray-100"
    @click="$emit('click')"
  >
    <slot name="icon" />
    <div class="whitespace-nowrap text-sm font-bold">
      <slot name="default" />
    </div>
  </button>
</template>
